module.exports = __webpack_public_path__ + "assets/images/project/malaysia-desktop.jpg?v=2083f18f";